<template>
  <header id="header" class="navbar navbar-fixed-top bg-white box-shadow b-b b-light" :style="NavbarColor" data-spy="affix" data-offset-top="1">
    <div class="container">
      <div class="navbar-header">        
        <a href="#" class="navbar-brand"><img style="max-height: 36px" src="../../assets/images/LogoDMSBianco.png" class="m-r-sm"></a>
        <button class="btn btn-link visible-xs" type="button" data-toggle="collapse" data-target=".navbar-collapse">
          <i class="fa fa-bars"></i>
        </button>
      </div>
    </div>
  </header>

</template>

<script>
import { COLORI_PANTONE, SystemInformation } from '@/SystemInformation';
export default 
{
    name: "VUEHeader",
    data() 
    {
     return { 
               SystemInformation : SystemInformation,
               NavbarColor       : {'background-color' : COLORI_PANTONE.Arancione},
            };
    },
    components: 
    {
       
    },
    computed:
    {
       LoginMenu : 
       {
          get() 
          {
            if(SystemInformation.AdvQuery != undefined)
              return (SystemInformation.AdvQuery.CurrentUserLogged ? "Entra" : "Login");
            else return('-');
          }
       }
    },
    methods: 
    {
      OnClickLogin()
      {
        if(SystemInformation.AdvQuery.CurrentUserLogged)
           this.$router.push('/appMainWindow/Dashboard');
        else this.$router.push('/');
      },
    },
};
</script>